import React from 'react'

import { Container, TextBox, Group, IconBox, Button, Title, Description } from './success-step-style'
import Like from '@assets/images/icon-like.svg'
import Header from '@components/layout/header'
import environment from '@environment'
import Layout from '@components/layout/layout'

const SuccessStep = () => {
  const managerPortalURL = environment.managerPortalURL

  return (
    <Layout>
      <Header />
      <Container className="row">
        <Title>Obrigado por escolher a Aberto. </Title>
        <Description>Agora você já pode acessar nosso sistema enquanto analisamos suas informações.</Description>
        <Group>
          <IconBox>
            <img src={Like} />
          </IconBox>
          <TextBox>
            <p>Fique atento.</p>
            <p> Vamos avisar assim que tudo estiver liberado para você poder criar suas ofertas.</p>
          </TextBox>
        </Group>
        <Button href={managerPortalURL} className="col-sm-6">
          acessar a plataforma da Aberto
        </Button>
      </Container>
    </Layout>
  )
}

SuccessStep.propTypes = {}
SuccessStep.displayName = 'SuccessStep_Page'

export default SuccessStep
